<template>
  <div class="modal" tabindex="-1" id="modalLottery">

    <!--GAME INTERFACE-->
    <transition name="">
      <div class="modal-dialog" v-if="lotteryModalInterface == 1">
        <div class="modal-content modal-game__bg rounded-0" data-bs-theme="dark">
          <button type="button" class="btn-close position-absolute end-0 p-2" data-bs-dismiss="modal"
            aria-label="Close"></button>
          <div class="modal-body pt-0">
            <div class="container">
              <div class="row text-center pt-3 justify-content-center">
                <div class="col-5 d-flex justify-content-center align-items-center py-3">
                  <img src="../assets/images/campaigns/2026/4th-july-26/lbl-01.png" alt="" class="w-75 lbl-animate">
                </div>
                <div class="col-7 d-flex justify-content-center align-items-center">
                  <img src="../assets/images/campaigns/2026/4th-july-26/logo.png" alt="" class="w-50">
                </div>
                <div class="col-12 pt-2 pb-1 d-grid lh-1" style="min-height: 2rem;">
                  <span class="lbl-main fs-1">Can you Unlock your <br>
                    Vacation Bonus?</span>
                </div>
                <div class="col-12 pt-2 pb-1 d-grid" style="min-height: 2rem;">
                  <span v-if="gameState === 'idle'" class="lbl-description">WATCH THE SEQUENCE ... REPEAT IT ... <br>
                    AND REVEAL YOUR REWARD.</span>
                  <span v-else-if="gameState === 'showing'" class="lbl-status">Memorize the pattern...</span>
                  <span v-else-if="gameState === 'input'" class="lbl-status">Your turn! Repeat the pattern.</span>
                  <span v-else-if="gameState === 'failed'" class="lbl-status lbl-status--failed">Wrong! Try
                    again.</span>
                </div>
                <div class="col-12 d-flex justify-content-center pt-2 pb-1">
                  <div class="wheel" :class="{ 'wheel--disabled': gameState !== 'input' }">
                    <div class="quadrant q-cream" :class="{ active: activeQuadrant === 'cream' }"
                      @click="playerClick('cream')"></div>
                    <div class="quadrant q-red" :class="{ active: activeQuadrant === 'red' }"
                      @click="playerClick('red')"></div>
                    <div class="quadrant q-yellow" :class="{ active: activeQuadrant === 'yellow' }"
                      @click="playerClick('yellow')"></div>
                    <div class="quadrant q-blue" :class="{ active: activeQuadrant === 'blue' }"
                      @click="playerClick('blue')"></div>
                    <div class="wheel-center"></div>
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-center pt-3"
                  v-if="gameState === 'idle' || gameState === 'failed'">
                  <div class="btn btn-click rounded-pill py-2 px-5" @click="play()">
                    {{ gameState === 'failed' ? 'TRY AGAIN' : 'START' }}
                  </div>
                </div>
                <div class="col-12 terms-lbl text-center pt-3 pb-4">
                  <span>Does not apply with other promotions.</span><br>
                  <span>Valid with the purchase of a Vacation Package to Mexico.</span><br>
                  <span>*Only with the purchase of a $599 package.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!--PRIZE INTERFACE-->
    <transition name="fade">
      <div class="modal-dialog" v-if="lotteryModalInterface == 2">
        <div class="modal-content modal-game__bg rounded-0">
          <div class="modal-header justify-content-center p-0">
            <div class="col-12">
              <div class="pt-5 pb-2 d-grid justify-content-center justify-content-center text-center">
                <span class="fw-bold text-white passion-one-bold">You got it!!</span>
                <span class="text-white">YOUR VACATION BONUS IS READY:</span>
              </div>
            </div>
            <div data-bs-theme="dark">
              <button type="button" class="btn-close position-absolute end-0 p-3 top-0" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
          </div>
          <div class="modal-body pt-0">
            <div class="container">
              <div class="row text-center justify-content-center">
                <div class="col-6 justify-content-center pb-4">
                  <img :src="prize.imgUrl" alt="" class="w-100">
                </div>
                <div class="col-12">
                  <TheLotteryForm :prizeCode="prize.code" :prizeName="prize.name" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import TheLotteryForm from './TheLotteryForm.vue';
import Confetti from 'canvas-confetti'

export default {
  data() {
    return {
      title: 'The Lottery',
      lotteryModalInterface: 1,
      now: new Date(),
      fromDate: new Date(2026, 6, 1, 0, 0, 0),
      toDate: new Date(2026, 6, 7, 23, 59, 59),
      gamePattern: [],
      playerPattern: [],
      activeQuadrant: null,
      gameState: 'idle', // idle | showing | input | failed
      gameColors: ['cream', 'red', 'yellow', 'blue'],
      patternLength: 3,
      prize: {
        name: '',
        code: '',
        imgUrl: '',
      },
    }
  },
  components: {
    TheLotteryForm
  },
  methods: {
    showModal() {
      let bannerModal = document.querySelector('#modalLottery', { backdrop: false });
      //eslint-disable-next-line
      const bannerModalInstance = new bootstrap.Modal(bannerModal);
      bannerModalInstance.show();
    },
    play() {
      this.gamePattern = this.generatePattern(this.patternLength);
      this.playerPattern = [];
      this.activeQuadrant = null;
      this.gameState = 'showing';
      this.showPattern();
    },
    generatePattern(length) {
      return Array.from({ length }, () => this.gameColors[Math.floor(Math.random() * 4)]);
    },
    showPattern() {
      let i = 0;
      const showNext = () => {
        if (i >= this.gamePattern.length) {
          this.gameState = 'input';
          return;
        }
        this.activeQuadrant = this.gamePattern[i];
        setTimeout(() => {
          this.activeQuadrant = null;
          i++;
          setTimeout(showNext, 300);
        }, 700);
      };
      setTimeout(showNext, 500);
    },
    playerClick(color) {
      if (this.gameState !== 'input') return;

      const step = this.playerPattern.length;

      this.activeQuadrant = color;
      setTimeout(() => { this.activeQuadrant = null; }, 250);

      if (color !== this.gamePattern[step]) {
        setTimeout(() => { this.gameState = 'failed'; }, 250);
        return;
      }

      this.playerPattern.push(color);

      if (this.playerPattern.length === this.gamePattern.length) {
        this.gameState = 'idle';
        setTimeout(() => {
          this.lotteryModalInterface = 2;
          this.getConfetti();
        }, 500);
      }
    },
    setRandomNumber(max) {
      return Math.floor(Math.random() * max);
    },
    setPrize() {
      switch (this.setRandomNumber(5)) {
        case 0:
          this.prize.code = "#VAL40CITIES";
          this.prize.name = "40 CITIES CERTIFICATE";
          this.prize.imgUrl = require('@/assets/images/campaigns/2026/prizes/prize-01.png')
          break;
        case 1:
          this.prize.code = "#VAL6MONTHS";
          this.prize.name = "+6 MONTHS TO TRAVEL";
          this.prize.imgUrl = require('@/assets/images/campaigns/2026/prizes/prize-02.png')
          break;
        case 2:
          this.prize.code = "#1FREEORLANDO";
          this.prize.name = "FREE ORLANDO TRIP";
          this.prize.imgUrl = require('@/assets/images/campaigns/2026/prizes/prize-03.png')
          break;
        case 3:
          this.prize.code = "#1FREEVEGAS";
          this.prize.name = "FREE VEGAS TRIP";
          this.prize.imgUrl = require('@/assets/images/campaigns/2026/prizes/prize-04.png')
          break;
        case 4:
          this.prize.code = "#VALAMWEEK";
          this.prize.name = "AMAZING WEEK";
          this.prize.imgUrl = require('@/assets/images/campaigns/2026/prizes/prize-05.png')
          break;
        default:
          break;
      }
    },
    getConfetti() {
      Confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 2000,
        shapes: ['circle'],
        colors: ['#cc2f3e', '#f0be10', '#3d93cc', '#ffffff']
      })
    }
  },
  mounted() {
    // this.setPrize();
    // this.showModal();
  },
  destroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
.modal-game__bg {
 background-image: url('../assets/images/campaigns/2026/4th-july-26/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* WHEEL */
.wheel {
  width: 260px;
  height: 260px;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  border: 10px solid #1a1a1a;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.7);
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 6px;
  background: #1a1a1a;
}

.quadrant {
  cursor: pointer;
  transition: filter 0.15s ease, background-color 0.15s ease;
}

.wheel--disabled .quadrant {
  cursor: default;
}

.q-cream {
  background: #ddd0be;
}

.q-red {
  background: #cc2f3e;
}

.q-yellow {
  background: #f0be10;
}

.q-blue {
  background: #3d93cc;
}

.q-cream.active {
  background: #fff5ec;
  filter: drop-shadow(0 0 12px #fff5ec);
}

.q-red.active {
  background: #ff5566;
  filter: drop-shadow(0 0 12px #ff5566);
}

.q-yellow.active {
  background: #ffe84a;
  filter: drop-shadow(0 0 12px #ffe84a);
}

.q-blue.active {
  background: #70ccff;
  filter: drop-shadow(0 0 12px #70ccff);
}

.wheel-center {
  position: absolute;
  width: 56px;
  height: 56px;
  background: #1a1a1a;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  box-shadow: 0 0 0 4px #2a2a2a;
}

/* STATUS LABELS */
.lbl-status {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #fff;
  letter-spacing: 1px;
}

.lbl-status--failed {
  color: #ff5566;
}

.lbl-main {
  color: #fff;
  font-weight: 700;
  font-size: 1.5rem;
  font-family: "Oleo Script", system-ui;
}

.lbl-description {
  font-size: 12px;
  color: #fff;
  font-size: 1rem;

}

/* HEADER LABEL ANIMATION */
.lbl-animate {
  animation: float ease-in-out 3s infinite alternate;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }

  100% {
    transform: translateY(-8px);
  }
}

/* BUTTON */
.btn-click {
  background-color: #f23740;
          box-shadow: 183, 1, 23, 1px #b70117;
        -webkit-box-shadow: 0px 6px 0px 0px #b70117;
        -moz-box-shadow: 183, 1, 23, 1px #b70117;
  color: #fff;
  font-family: 'Bebas Neue', sans-serif;
  font-size: 1.8rem;
  letter-spacing: 2px;
}

.btn-click:hover {
  background-color: #e03040;
  color: #fff;
  border: solid 2px #fff;
}

.btn-close {
  background-color: transparent !important;
}

.terms-lbl {
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.7rem;
}

/* PRIZE SCREEN */
.modal-header {
  background-color: transparent;
  border: none !important;
  border-radius: 0 !important;
}

.passion-one-bold {
  font-family: "Oleo Script", system-ui;
  font-weight: 700;
  font-style: normal;
  text-shadow: #003543 2px 2px 0px;
  font-size: 3rem;
}

.lbl-condition {
  font-size: .8rem;
  font-family: "Montserrat", sans-serif;
  letter-spacing: 1px;
}

/* TRANSITIONS */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
